// AUTO-GENERATED list of SECURITY DEFINER functions that authorize on a
// `_clerk_user_id` argument. EXECUTE is revoked from anon/authenticated in the
// database; they may only be reached through the Clerk-verified `secure-rpc`
// edge function, which injects the verified caller id server-side.
export const PROTECTED_RPCS: readonly string[] = [
  "manager_notes_list",
  "manager_notes_upsert",
  "manager_notes_delete",
  "admin_action_payout_request",
  "admin_add_business_partner",
  "admin_add_extra_league",
  "admin_add_payment_ambassador",
  "admin_add_payment_gateway",
  "admin_approve_referral_reward",
  "admin_approve_signup",
  "admin_approve_waitlist_batch",
  "admin_assign_payment_method",
  "admin_award_streak_free_entry",
  "admin_clear_transaction_reference",
  "admin_competition_participant_counts",
  "admin_create_champions_league_competition",
  "admin_create_competition",
  "admin_create_country",
  "admin_create_influencer",
  "admin_create_pl_news",
  "admin_create_pl_video",
  "admin_delete_competition",
  "admin_delete_competition_milestone",
  "admin_delete_extra_league",
  "admin_delete_payment_ambassador",
  "admin_delete_payment_gateway",
  "admin_delete_pl_news",
  "admin_delete_pl_video",
  "admin_delete_user_profile",
  "admin_delete_winner",
  "admin_fetch_winners",
  "admin_financials_lock_day",
  "admin_flag_profile_resolution",
  "admin_fpl_pool_add",
  "admin_fpl_pool_classify",
  "admin_fpl_pool_delete",
  "admin_fpl_pool_list",
  "admin_fpl_pool_release",
  "admin_fpl_pool_reuse",
  "admin_fpl_pool_set_threshold",
  "admin_fpl_pool_update",
  "admin_get_apk_analytics",
  "admin_get_activity_logs",
  "admin_get_ussd_merchant_settings",
  "admin_get_ambassador_status",
  "admin_get_ambassador_transactions",
  "admin_get_competition_capacity",
  "admin_get_fpl_pool_stats",
  "admin_get_swiss_pairings",
  "admin_get_swiss_standings",
  "admin_get_user_analytics",
  "admin_get_user_audit_logs",
  "admin_get_user_competition_detail",
  "admin_get_user_details",
  "admin_get_user_onboarding_list",
  "admin_get_user_signup_analytics",
  "admin_grant_free_entry_request",
  "admin_insert_winner",
  "admin_list_business_partners",
  "admin_list_competition_league_ids",
  "admin_list_competition_signups",
  "admin_list_competitions",
  "admin_list_countries",
  "admin_list_email_notifications",
  "admin_list_extra_leagues",
  "admin_list_fpl_duplicates",
  "admin_list_fpl_team_id_change_requests",
  "admin_list_free_entry_requests",
  "admin_list_fx_rate_settings",
  "admin_list_influencer_payout_requests",
  "admin_list_influencers",
  "admin_list_payment_ambassadors",
  "admin_list_payment_gateways",
  "admin_list_payment_methods",
  "admin_list_pending_signups",
  "admin_list_pl_news",
  "admin_list_pl_videos",
  "admin_list_referral_milestones",
  "admin_list_streak_eligible_users",
  "admin_list_support_tickets",
  "admin_list_transactions",
  "admin_list_upi_ambassadors",
  "admin_list_user_profiles",
  "admin_list_users_by_country",
  "admin_list_users_for_push",
  "admin_list_waitlist",
  "admin_log_push_send",
  "admin_publish_extra_league",
  "admin_recalculate_competition_financials",
  "admin_reject_free_entry_request",
  "admin_reject_signup",
  "admin_reject_waitlist_entry",
  "admin_replace_extra_league",
  "admin_resolve_fpl_team_id_change",
  "admin_resolve_push_targets",
  "admin_respond_support_ticket",
  "admin_search_profiles",
  "admin_set_capacity_thresholds",
  "admin_set_champions_league_config",
  "admin_set_competition_auto_process",
  "admin_set_competition_badge",
  "admin_set_competition_global",
  "admin_set_competition_status",
  "admin_set_country_payout_friendly",
  "admin_set_payment_ambassador_active",
  "admin_set_payment_ambassador_global",
  "admin_set_stage_payouts",
  "admin_set_ussd_merchant_settings",
  "admin_toggle_country_onboarding",
  "admin_toggle_country_status",
  "admin_toggle_feature",
  "admin_toggle_pl_news_publish",
  "admin_toggle_pl_video_publish",
  "admin_toggle_winner_publish",
  "admin_update_competition_fpl_league",
  "admin_update_default_telegram_chat",
  "admin_update_extra_league",
  "admin_update_influencer",
  "admin_update_influencer_code",
  "admin_update_pl_news",
  "admin_update_pl_video",
  "admin_update_winner",
  "admin_upsert_competition_milestone",
  "admin_upsert_country_telegram",
  "calculate_knockout_stage_payouts",
  "check_onboarding_status",
  "create_free_entry_request",
  "create_or_update_profile",
  "create_support_ticket",
  "delete_payment_method",
  "ensure_referral_signup",
  "generate_invite_redirect_token",
  "get_admin_notification_counts",
  "get_admin_notifications",
  "get_cached_leaderboards",
  "get_cl_opponent_overview",
  "get_competition_leaderboard_participants",
  "get_h2h_battles",
  "get_influencer_dashboard",
  "get_my_extra_league_ids",
  "get_my_fpl_profile",
  "get_my_influencer_earnings",
  "get_my_influencer_profile",
  "get_my_onboarding",
  "get_my_profile_full",
  "get_my_profile_state",
  "get_my_support_tickets",
  "get_my_waitlist_status",
  "get_open_competitions_for_user",
  "get_open_h2h_challenges",
  "get_partner_dashboard",
  "get_pending_referrals",
  "get_profile_country",
  "get_profile_id_by_clerk",
  "get_profile_names_by_ids",
  "get_referral_stats",
  "get_unread_rejection_count",
  "get_user_admin_roles",
  "get_user_approved_competitions",
  "get_user_chat_history",
  "get_user_country_currency",
  "get_user_entries",
  "get_user_favourite_team",
  "get_user_leaderboards",
  "get_user_streak_info",
  "get_user_transactions",
  "get_user_winnings_total",
  "join_competition_and_log",
  "join_competition_waitlist",
  "link_and_verify_influencer",
  "link_referral_to_user",
  "list_admin_collaborators",
  "list_payment_methods",
  "list_referral_rewards",
  "list_transactions",
  "log_user_action",
  "log_user_activity",
  "mark_referral_converted",
  "mark_rejections_as_read",
  "notif_get_prefs",
  "notif_list",
  "notif_mark_all_read",
  "notif_mark_read",
  "notif_password_changed",
  "notif_unread_count",
  "notif_upsert_pref",
  "request_fpl_team_id_change",
  "mark_admin_notifications_read",
  "request_influencer_payout",
  "request_referral_reward",
  "save_push_subscription",
  "save_user_fpl_team",
  "set_my_pending_referral_code",
  "save_user_onboarding",
  "track_competition_streak",
  "update_my_profile",
  "upsert_payment_method",
  "user_submit_payment",
  "admin_create_competition_host",
  "admin_financials_hosted",
  "admin_financials_influencers",
  "admin_list_competition_hosts",
  "admin_set_competition_host",
  "admin_update_hosted_request_status",
  "get_hosted_competition_requests",
  "get_my_hosted_requests",
  "admin_get_hosted_request_detail",
  "admin_regenerate_host_token",
  "admin_unbind_host",
  "claim_host_access",
  "get_host_dashboard",
  "submit_hosted_competition_request",
  "admin_admit_user_to_competition",
  "admin_set_signup_amount",
  "admin_set_country_ontech",
  "admin_set_country_ussd",
  "admin_create_promotion",
  "admin_list_promotions",
  "admin_set_promotion_status",
  "admin_update_promotion",
  "admin_delete_promotion",
  "create_bundle_signups",
  "get_active_promotions_for_user",
  "is_competition_host",
  "get_referral_lead_rate",
  "submit_referral_leads",
  "get_my_referral_leads",
  "admin_list_referral_leads",
  "admin_update_referral_lead_status",
  "admin_mark_referral_leads_paid",
  "admin_list_referral_lead_rates",
  "admin_upsert_referral_lead_rate",
  "track_referee_signup",
  "get_my_competition_payment_states",
  "get_my_signup_installments",
  "get_my_competition_payments",
  "admin_set_competition_partial_config",
  "admin_list_partial_signups",
  "admin_get_signup_payment_detail",
  "admin_resolve_partial_payment",
  "admin_partial_payment_summary",
  "manager_article_create",
  "manager_article_update",
  "manager_article_delete",
  "manager_article_reply_create",
  "manager_article_reply_delete",
  "manager_article_react",
  "manager_article_save",
  "manager_article_share",
  "manager_article_view",
  "manager_article_engagement_state",
  "manager_article_set_hashtags",
  "manager_article_report",
  "manager_article_report_resolve",
  "manager_article_reports_list",
  "manager_article_moderate",
  "manager_article_admin_report_context",
  "manager_article_admin_get",
  "manager_article_media_add",
  "manager_article_media_delete",
  "manager_article_media_list",

];

export const PROTECTED_RPC_SET = new Set(PROTECTED_RPCS);
